import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import Header from './Header';
import './Terms.css';

const Terms = () => {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch('/terms.md')
      .then((res) => res.text())
      .then((text) => setContent(text))
      .catch((err) => console.error('Failed to load terms.md:', err));
  }, []);

  return (
    <div className="Landing__container">
      <Header />
      <main className="Terms__content">
        <ReactMarkdown>{content}</ReactMarkdown>
      </main>
    </div>
  );
};

export default Terms; 